import { memo } from "react"
import { Box, CardBody, CardFooter, CardHeader, FormControl, FormErrorMessage, FormLabel, Input } from "@chakra-ui/react";
import { useSoCouponSurveyQuestionRegisterForm } from "../../../hooks/socoupon/useSoCouponSurveyQuestionRegisterForm";
import { useSubmitSoCouponSurveyQuestionRegister } from "../../../hooks/socoupon/useSubmitSoCouponSurveyQuestionRegister";
import { useParams } from "react-router-dom";
import { DarkShadowCard } from "../../molecules/card/DarkShadowCard";
import { CardHeading } from "../../molecules/card/CardHeading";
import { RiFileTextLine } from "react-icons/ri";
import { SubmitBtn } from "../../atoms/button/SubmitBtn";


export const SoCouponSurveyQuestionRegister: React.FC = memo(() => {
  const { restaurantId } = useParams()
  const { handleSubmit, register, errors, isSubmitting } = useSoCouponSurveyQuestionRegisterForm()
  const onSubmit = useSubmitSoCouponSurveyQuestionRegister(restaurantId)
  return (
    <Box m='auto' w={{ base: '100%', md: '60%' }}>
      <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
        <DarkShadowCard>
          <CardHeader>
            <CardHeading icon={<RiFileTextLine size="20px" />} heading='アンケート登録'/>
          </CardHeader>
          <CardBody py={2}>
            <FormControl isRequired isInvalid={!!errors.question}>
              <FormLabel>アンケート質問</FormLabel>
              <Input type="input" {...register('question')} />
              <FormErrorMessage>{errors.question?.message}</FormErrorMessage>
            </FormControl>
          </CardBody>
          <CardFooter>
            <SubmitBtn isLoading={isSubmitting}>登録</SubmitBtn>
          </CardFooter>
        </DarkShadowCard>
      </form>
    </Box>
  );
});